import React from 'react';
import CrudTable from '../../components/admin/CrudTable';

export default function ManagePills() {
  return (
    <CrudTable
      entity="pills"
      title="Ana səhifə düymələri (pills)"
      defaults={{ side: 'left', label: '', content: '', image: '', animation_type: 'none', slides: [], order: 0 }}
      fields={[
        { key: 'label', label: 'Mətn', type: 'text' },
        { key: 'side', label: 'Tərəf', type: 'select', options: [
          { value: 'left', label: 'Sol' }, { value: 'right', label: 'Sağ' },
        ]},
        { key: 'content', label: 'Məzmun (formatlaşdırıla bilər)', type: 'richText' },
        { key: 'image', label: 'Şəkil', type: 'image' },
        { key: 'animation_type', label: 'Animasiya növü', type: 'select', options: [
          { value: 'none', label: 'Yoxdur' },
          { value: 'fade', label: 'Fade' },
          { value: 'slide', label: 'Slide' },
          { value: 'scale', label: 'Scale' },
        ]},
        { key: 'slides', label: 'Slaydlar', type: 'imageList' },
        { key: 'order', label: 'Sıra', type: 'number' },
      ]}
      listColumns={[
        { key: 'label', label: 'Mətn' },
        { key: 'side', label: 'Tərəf', render: (v) => v === 'left' ? 'Sol' : 'Sağ' },
        { key: 'order', label: 'Sıra' },
      ]}
    />
  );
}
